import formatMoney from "../../../formatMoney";

const monthMap = {
  January: 1,
  February: 2,
  March: 3,
  April: 4,
  May: 5,
  June: 6,
  July: 7,
  August: 8,
  September: 9,
  October: 10,
  November: 11,
  December: 12,
};

export function buildDateQuery({ type, year, years, month, quarter, half }) {
  let query = {};

  if (type === "Monthly") {
    const monthNumber = monthMap[month];
    const startDate = new Date(year, monthNumber - 1, 1);
    const endDate = new Date(year, monthNumber, 0, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  } else if (type === "Yearly") {
    const startDate = new Date(year, 0, 1);
    const endDate = new Date(year, 11, 31, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  } else if (type === "Bi-Yearly") {
    const halves = {
      "1st Half": 1,
      "2nd Half": 2,
    };

    const halvesNumber = halves[half];
    const startMonth = (halvesNumber - 1) * 6;
    const endMonth = startMonth + 5;
    const startDate = new Date(year, startMonth, 1);
    const endDate = new Date(year, endMonth, 31, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  } else if (type === "Quarterly") {
    const quarters = {
      "1st Quarter": 1,
      "2nd Quarter": 2,
      "3rd Quarter": 3,
      "4th Quarter": 4,
    };
    const quarterNumber = quarters[quarter];

    if (!quarterNumber) {
      throw new Error(
        `Invaldi value: ${quarter} , Expected Vlaue: "Q1","Q2","Q3" and "Q4"`,
      );
    }
    const startMonth = (quarterNumber - 1) * 3;
    const endMonth = startMonth + 2;
    const startDate = new Date(year, startMonth, 1);
    const endDate = new Date(year, endMonth + 1, 0, 23, 59, 59, 999);
    query.date = { gte: startDate.toISOString(), lte: endDate.toISOString() };
  }

  return query;
}

export function parseMoney(value) {
  if (!value) return 0;
  return parseFloat(value.replace(/,/g, ""));
}

export function getTopSales(data) {
  // const sales = data.filter((item) => item.type === "sale");
  // if (sales.length === 0) return 0;
  if (data.length === 0) return 0;
  const top = Math.max(...data.map((item) => parseMoney(item.gross)));
  return formatMoney(top);
}

export function getTotalGross(data) {
  const totalPurchase = data
    // .filter((item) => item.type === "purchase")
    .reduce((sum, item) => sum + parseMoney(item.gross), 0);

  return totalPurchase;
}

export function getNetProfit(data) {
  const totalSales = data
    .filter((item) => item.type === "sale")
    .reduce((sum, item) => sum + parseMoney(item.gross), 0);

  const totalPurchases = getTotalGross(data);

  return totalSales - totalPurchases;
}

export function getAllYears() {
  const currentYear = new Date().getFullYear();
  const startYear = 2000;

  const years = [];
  for (let year = currentYear; year >= startYear; year--) {
    years.push(`${year}`);
  }

  return years;
}
